import './NotFound.css';

const NotFound = () => {
    return (
        <div className="notFound">
            <h2>Sorry</h2>
            <p>That page cannot be found</p>
            <p>404 Error</p>
        </div>
    )
}

export default NotFound;